export default __webpack_public_path__ + "static/media/miscellaneous21.970e318b.png";